import { SetupContext, getCurrentInstance, ref } from 'vue';
// eslint-disable-next-line import/no-extraneous-dependencies
import debounce from 'lodash/debounce';
import { Feed } from '@/api/feed';

type PhotoActionItemProps = {
    index?: number;
    feed?: Feed;
    isLoginStatus?: boolean;
};

export const PhotoActionItemAppSetup = (props: PhotoActionItemProps, ctx: SetupContext<Array<'onCommentBtnClick' | 'sendActionRecoLog'>>) => {
    const isLiked = ref(false);

    const excuteLikeAction = debounce(async () => {
        ctx.emit('sendActionRecoLog', 'PWA_LIKE_PHOTO');
        isLiked.value = true;
    }, 300);

    const excuteCommentAction = debounce(async () => {
        ctx.emit('sendActionRecoLog', 'PWA_COMMENT_BUTTON');
        ctx.emit('onCommentBtnClick');
    });

    const excuteDownloadAction = debounce(async () => {
        // ctx.emit('sendActionRecoLog', 'PWA_DOWNLOAD_PHOTO');
        ctx.emit('sendActionRecoLog', 'PWA_DOWNLOAD_BUTTON');
        try {
            const videoUrl = props.feed?.main_mv_urls?.find?.(mv => !!mv?.url)?.url || '';
            if (!videoUrl) {
                return;
            }

            /**
             * @zh 目前只有视频资源
             */
            const res = await window.$yoda?.invoke?.('component.saveMediaToAlbum', {
                url: videoUrl,
                mediaType: 'video',
            });
            console.log(res, 'res');
        } catch (error) {
            console.log(error);
        }
    });

    return {
        isLiked,
        excuteLikeAction,
        excuteCommentAction,
        excuteDownloadAction,
    };
};
